module.exports = __webpack_public_path__ + "static/img/daily.15fa012.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/daily.gif
// module id = 4ky0
// module chunks = 1